import { FrameViews } from "@com.mgmtp.a12.client/client-core/lib/core/frame";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { VisibleView } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/master-detail/main/master-detail.api";
import { MasterDetail } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/master-detail/main/master-detail.view";

export const CustomMasterDetailLayout: FrameViews.Layout = {
	component: function CustomMasterDetailLayout(props: FrameViews.LayoutProps) {
		const views = props.views;

		const createVisibleView = (view: View, index: number): VisibleView => {
			const { name, activityId, ...rest } = view;

			const ViewComponent = props.viewProvider(name);
			const ProgressComponent = props.progressComponentProvider(props.regionReference, name);

			return {
				element: (
					<ProgressComponent activityId={activityId}>
						<ViewComponent name={name} activityId={activityId} ariaLevel={index + 1} {...rest} />
					</ProgressComponent>
				),
				key: `${index}-${name}`
			};
		};

		return <MasterDetail {...props} visibleViews={views.map(createVisibleView)} animation={{ enabled: false }} />;
	}
};
